import { call, put, takeEvery } from 'redux-saga/effects';
import { bigCommerceActionCreators, BigCommerceApiKeys, FetchBigCommerceStores, IBigCommerceStore } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { uiActionCreators } from '../../ui';
import * as api from '../bigCommerceApi';

function* fetchBigCommerceStores(action: FetchBigCommerceStores) {
  yield put(uiActionCreators.toggleLoading('bigCommerceStores'));
  const response: IApiExecuteRespone<IBigCommerceStore[]> = yield call(api.fetchBigCommerceStores);

  if (!response.requestFailed && response.value) {
    yield put(bigCommerceActionCreators.setStores(response.value));
  } else {
    // TODO - show error message
  }

  yield put(uiActionCreators.toggleLoading('bigCommerceStores'));
}

export function* watchFetchBigCommerceStores() {
  yield takeEvery(BigCommerceApiKeys.FETCH_BIG_COMMERCE_STORES, fetchBigCommerceStores);
}
